import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import { BrowserRouter as Router } from "react-router-dom";
import { LanguageProvider } from "./utils/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <div className="dark:bg-white/[0.99]">
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </div>
    </Router>
  </React.StrictMode>
);
